<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-title>{{ 'ADRESSBUCH' | translate }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="padding-16">
    <div class="flex flex-column gap-8">
      @for (user of users(); track user.id) {
        <work-ui-infoblock
          [avatarImgSrc]="user.userImage ? (user.userImage.fileSrcThumbnail | prependServerToFileSrc) : null"
          [label]="user.jobtitle || ''"
          [title]="user.firstName! + ' ' + user.lastName! || ''"
          [subtitle]="user.mobileprivate"
          [withAvatar]="true"
          [textCenteredVertically]="true"
          [clickable]="true"
          [routerLink]="['/mitarbeitende', 'adressbuch', 'details', user.id]"
          routerDirection="forward"
          avatarStatus="none" />
      }
    </div>
  </div>
</ion-content>
